import { render, staticRenderFns } from "./ImportCompanyAttributesModal.vue?vue&type=template&id=d065ef42&scoped=true&"
import script from "./ImportCompanyAttributesModal.vue?vue&type=script&lang=js&"
export * from "./ImportCompanyAttributesModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportCompanyAttributesModal.vue?vue&type=style&index=0&id=d065ef42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d065ef42",
  null
  
)

export default component.exports